export default class DataSourceStore {
    constructor(dataSource) {
        this.getRequestsFromQueries = async ({ queries, request, }) => {
            const requestInformations = await Promise.all(queries.map((query) => this.getRequestsFromQuery({ query, request })));
            return requestInformations.flat();
        };
        this.getRequestsFromQuery = ({ query, request, }) => {
            return this.dataSource
                .getRequestsFromQuery({ query, request })
                .then((requestInformations) => requestInformations.map((requestInfo) => ({
                ...requestInfo,
                cacheSettings: query.cacheSettings,
            })));
        };
        this.initiateRequest = (request, requestInformations) => {
            this.dataSource.initiateRequest(request, requestInformations);
        };
        this.dataSource = dataSource;
    }
}
